export class EmailMarketingList {
    constructor(
        public listId: string,
        public displayName : string
    ) {
    }
}
